import { render, staticRenderFns } from "./BotSettings.vue?vue&type=template&id=c93746be"
import script from "./BotSettings.vue?vue&type=script&lang=js"
export * from "./BotSettings.vue?vue&type=script&lang=js"
import style0 from "./BotSettings.vue?vue&type=style&index=0&id=c93746be&prod&lang=scss"
import style1 from "spinkit/spinkit.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports